import { FormsArchiveTableStatus, FormsTableStatus } from 'app-constants';

export const isExternalMember = (form) => {
  return !(form?.isOwner || form?.isSignatory || form?.isEditor);
};

export const getFilteredDataSourceByCategory = (formCategoryFilter, dataSource) => {
  let formData = [...dataSource];
  if (formCategoryFilter !== 'All Forms') {
    switch (formCategoryFilter) {
      case 'My Forms':
        formData = formData.filter((data) => data.isOwner);
        break;
      case 'Team Forms':
        formData = formData.filter((data) => !data.isOwner && data.isTeamForm);
        break;
      case 'External Forms':
        formData = formData.filter((data) => !data.isTeamForm && !data.isOwner);
        break;
    }
  }

  return formData;
};

export const addStatusInDataSource = (statusDataSource, status) => {
  return statusDataSource.map((data) => ({
    ...data,
    key: data.formDocumentId,
    status,
    IsSequential: data.isSequential,
    ...(status === FormsTableStatus.WaitingOnYou || status === FormsTableStatus.WaitingOnOthers
      ? { waitingOnYou: status === FormsTableStatus.WaitingOnYou }
      : {}),
  }));
};

export const prepareFormDataFromSource = (
  dataSource,
  formsData,
  search,
  justSignedFormProcessPublicId,
) => {
  const isArray = Array.isArray(formsData);

  for (const data of dataSource) {
    let keepItem = true;

    // if (search) {
    //   const { formName, address } = data;
    //   const lowerCasedSearch = search.toLowerCase();
    //   keepItem =
    //     formName.toLowerCase().includes(lowerCasedSearch) ||
    //     address?.toLowerCase().includes(lowerCasedSearch);
    // }

    if (!keepItem) continue;

    let addAtStart = false;

    if (
      justSignedFormProcessPublicId &&
      data.formProcessPublicId === justSignedFormProcessPublicId
    ) {
      if (data.status === FormsTableStatus.WaitingOnYou && (!data.IsSequential || !data.isOwner)) {
        const otherSignatories = ((data?.signatories as any) ?? []).filter((s) => !s.isYou);
        if (otherSignatories.some((s) => s.status !== 'Signed')) {
          data.status = FormsTableStatus.WaitingOnOthers;
        } else {
          data.status = FormsTableStatus.Finalizing;
        }
      }

      addAtStart = true;
    }

    switch (data.status) {
      case FormsTableStatus.WaitingOnYou:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.waitingOnYouData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.waitingOnYouData.push(data);
        }
        break;

      case FormsTableStatus.WaitingOnOthers:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.waitingOnOthersData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.waitingOnOthersData.push(data);
        }
        break;

      case FormsTableStatus.Declined:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.declinedData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.declinedData.push(data);
        }
        break;

      case FormsTableStatus.Draft:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.draftData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.draftData.push(data);
        }
        break;

      case FormsArchiveTableStatus.Voided:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.voidedData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.voidedData.push(data);
        }
        break;

      case FormsArchiveTableStatus.Complete:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.completedData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.completedData.push(data);
        }
        break;

      case FormsArchiveTableStatus.Canceled:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.cancelledData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.cancelledData.push(data);
        }
        break;

      default:
        if (addAtStart) {
          isArray ? formsData.unshift(data) : formsData.recentlyCompletedData.unshift(data);
        } else {
          isArray ? formsData.push(data) : formsData.recentlyCompletedData.push(data);
        }
        break;
    }
  }

  return formsData;
};

export const prepareFormsDataSource = (allFormsData, justSignedFormProcessPublicId, search) => {
  const {
    waitingOnYouForms = [],
    waitingOnOtherForms = [],
    draftForms = [],
    finalizingForms = [],
    recentlyCompletedForms = [],
    declinedForms = [],
    voidedForms = [],
    canceledForms = [],
    completedForms = [],
  } = allFormsData;

  let dataSource = [
    ...addStatusInDataSource(waitingOnYouForms, FormsTableStatus.WaitingOnYou),
    ...addStatusInDataSource(waitingOnOtherForms, FormsTableStatus.WaitingOnOthers),
    ...addStatusInDataSource(finalizingForms, FormsTableStatus.Finalizing),

    ...addStatusInDataSource(recentlyCompletedForms, FormsTableStatus.RecentlyCompleted),
    ...addStatusInDataSource(declinedForms, FormsTableStatus.Declined),
    ...addStatusInDataSource(draftForms, FormsTableStatus.Draft),

    ...addStatusInDataSource(voidedForms, FormsArchiveTableStatus.Voided),
    ...addStatusInDataSource(completedForms, FormsArchiveTableStatus.Complete),
    ...addStatusInDataSource(canceledForms, FormsArchiveTableStatus.Canceled),
  ];

  // dataSource = getFilteredDataSourceByCategory(formCategoryFilter, dataSource);

  const formsData: any = {
    waitingOnYouData: [],
    waitingOnOthersData: [],
    draftData: [],
    completedData: [],
    declinedData: [],
    voidedData: [],
    cancelledData: [],
    recentlyCompletedData: [],
  };

  return prepareFormDataFromSource(dataSource, formsData, search, justSignedFormProcessPublicId);
};

export const calculatePendingSignatures = (signatories) => {
  return signatories.filter(
    ({ status, Status }) =>
      (status || Status) === 'Requested' ||
      (Status || status) == 'Pending' ||
      (Status || status).toLowerCase().includes('waiting on'),
  ).length;
};

export const preparePaginatedDataSource = (
  dataSource,
  formCategoryFilter,
  search,
  justSignedFormProcessPublicId,
  formStatus,
) => {
  dataSource = addStatusInDataSource(dataSource, formStatus);
  dataSource = getFilteredDataSourceByCategory(formCategoryFilter, dataSource);
  return prepareFormDataFromSource(dataSource, [], search, justSignedFormProcessPublicId);
};

export const getNamePlaceHolder = (fullName) => {
  const nameArray = fullName.split(' ');
  const firstName = nameArray[0];
  const lastName = nameArray[nameArray.length - 1];
  return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
};
